import View from '../../view.js';
import DataTables from '../../components/dataTables.js';
import Messenger from '../../components/messenger.js';

class ETLImports extends View {
  constructor(props = {}) {
    super(props);
    this.nameRegex = /^\d+_/;
    this.subscription = false;
  }

  get dom() {
    return {
      TABLE: '.etl-imports',
      TOOGLE: '.etl-output',
    };
  }

  get events() {
    return {
      'click .etl-output': 'toogleOutput',
    };
  }

  destroy() {
    this.stopListening();
  }

  stopListening() {
    if (!this.subscription) {
      return;
    }
    Messenger.off(`/${currentCustomer}/etl_imports`, this.subscription);
    this.subscription = false;
  }

  _listen() {
    if (this.subscription) {
      return;
    }
    this.subscription = Messenger.on(`/${currentCustomer}/etl_imports`, () =>
      this.table.reload(),
    );
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  toogleOutput(e) {
    let target = $(e.target).parent('.etl-output'),
      row;

    e.preventDefault();
    if (target.hasClass('opened')) {
      target.removeClass('opened');
      target.html('<i class="fa fa-angle-down"></i> <span>Show</span>');
      target.parents('tr').next('.virtual').remove();
    } else {
      target.addClass('opened');
      target.html('<i class="fa fa-angle-up"></i> <span>Hide</span>');
      row = $(
        `<tr class="virtual"><td colspan="6">${target.next('#main-content').html()}</td></tr>`,
      );
      row.insertAfter(target.parents('tr'));
    }
  }

  _urlFor(data, endpoint) {
    return '/' + data[8] + '/etl_imports/' + data[7] + '/' + endpoint;
  }

  render() {
    let table = this.$(this.dom.TABLE),
      options;

    options = {
      serverSide: true,
      el: table,
      columns: window.da_grid_columns,
      filter: true,
      fixed: false,
      ajaxSource: table.data('source'),
      sorting: [[0, 'desc']],
      aoColumnDefs: [
        {
          aTargets: [1],
          mRender: (data, type, full) =>
            `<a href="${this._urlFor(full, 'input_file')}" target='_blank'>${data}</a>`,
        },
        {
          aTargets: [2],
          mRender: (data, type, full) =>
            `<a href="${this._urlFor(full, 'output_file')}" target='_blank'>${data}</a>`,
        },
        {
          aTargets: [5],
          mRender: (data) => {
            return `<a class="etl-output" href="#"><i class="fa fa-angle-down"></i> <span>Show</span></a><div class="hidden content">${data}</div>`;
          },
        },
      ],
    };

    this.table = new DataTables(options);
    this.table.start();
    this._listen();
  }
}

module.exports = ETLImports;
